import React from 'react';
import { images } from 'assets/images/import-images';
import { IContext } from 'context/reducers';

type Props = {
  context: IContext;
};

const SplashScreen: React.FC<Props> = props => {
  const {
    context: { loadingSplash },
  } = props;

  return (
    <>
      {loadingSplash && (
        <div id="SplashScreen">
          <img
            className="logo"
            src={images.voalaLoading}
            alt="logo voala by bancorbras"
          />
        </div>
      )}
    </>
  );
};

export default SplashScreen;
